// extracted by mini-css-extract-plugin
module.exports = {"CodeModal":"CodeModal_CodeModal__2b0en","modalTitle":"CodeModal_modalTitle__3nRZ8","modalBody":"CodeModal_modalBody__3iMxM"};